import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from "Modules/Loading"

const initialState = Immutable.Map({})
	.set('Get', new Immutable.List([]))
	.set('Response', new Immutable.List([]))
	.set('Search', new Immutable.List([]))
	.set('Excel', new Immutable.Map({}))
	.set('Reject', new Immutable.Map({}))
	.set('Set', new Immutable.Map({}))


/* Types */
export const GET_EXCEL = 'GET_EXCEL'
export const REJECT_PROPOSAL = 'REJECT_PROPOSAL'
export const SET_PROPOSAL = 'SET_PROPOSAL'


/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_EXCEL:
			return state.set('Excel', new Immutable.Map(action.Obj))
		case REJECT_PROPOSAL:
			return state.set('Reject', new Immutable.Map(action.Obj))
		case SET_PROPOSAL:
			return state.set('Set', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const exportEjecutivoExcel = (propuestaId) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/exportEjecutivoExcel',
			method: "POST",
			data: { propuestaId },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer',
		}).request().then(response => {
			dispatch(isLoading(false))

			const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileName = `propuesta-asignacion-${Utils.getToday()}.xlsx`
			const objectUrl = URL.createObjectURL(blob)
			const a = document.createElement('a')

			a.href = objectUrl
			a.download = fileName
			document.body.appendChild(a)
			a.click()

			document.body.removeChild(a)
			URL.revokeObjectURL(objectUrl)

			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const rejectEjectivo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/rejectEjectivo',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))

			dispatch({ type: REJECT_PROPOSAL, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const setEjectivo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/setEjectivo',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))

			dispatch({ type: SET_PROPOSAL, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const updateProjectEjectivo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateProjectEjectivo',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))

			dispatch({ type: SET_PROPOSAL, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateAuthorization = (form) => {

	let temp = {
		fechaAutorizacion: form.fechaFinAutoriza,
		organoId: form.item.organoId,
		propuestaId: form.propuestaId,
		usuario: sessionStorage.uid
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateAuthorization',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}




// WEBPACK FOOTER //
// ./src/modules/Filter/ProposalAssignmentEjec.js